/**
 * @generated SignedSource<<13611d2bce1f89aab77dfc0c1a2ea019>>
 * @relayHash f6b8110f5ba545a591d2b62d7541e0f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4971b9ad15faac4be78ffb2ad161f5508edd98913b088d599b2d846e1c844537

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConvoAiHomeThreadsInput = {
  promptOverride?: string | null | undefined;
  userId: string;
};
export type ThreadsV2_Query$variables = {
  cloudId: string;
  experience: string;
  homeThreadsInput: ConvoAiHomeThreadsInput;
  isEnabled: boolean;
  suggestedActionsV2Enabled: boolean;
};
export type ThreadsV2_Query$data = {
  readonly convoai_homeThreads?: {
    readonly " $fragmentSpreads": FragmentRefs<"RecommendedFeedInternal_AtlassianRecommendedFeed">;
  } | null | undefined;
};
export type ThreadsV2_Query = {
  response: ThreadsV2_Query$data;
  variables: ThreadsV2_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "homeThreadsInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedActionsV2Enabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "homeThreadsInput",
    "variableName": "homeThreadsInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "ConvoAiHomeThreadsThirdPartySource"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = {
  "concreteType": "ConfluenceBodies",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "length",
          "value": 300
        }
      ],
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": "excerpt(length:300)"
    }
  ]
},
v9 = [
  (v3/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ConfluencePage"
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "ConfluenceBlogPost"
},
v12 = [
  (v8/*: any*/),
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": (v9/*: any*/),
        "type": "ConfluenceWhiteboard"
      },
      (v7/*: any*/)
    ]
  }
],
v13 = [
  {
    "concreteType": "JiraRichText",
    "kind": "LinkedField",
    "name": "richText",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraADF",
        "kind": "LinkedField",
        "name": "adfValue",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraAdfToConvertedPlainText",
            "kind": "LinkedField",
            "name": "convertedPlainText",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "plainText"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "summary"
      },
      (v2/*: any*/)
    ]
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = [
  (v4/*: any*/),
  (v15/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v2/*: any*/)
],
v17 = [
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v14/*: any*/)
        ],
        "type": "ConfluencePage"
      }
    ]
  },
  (v15/*: any*/),
  {
    "concreteType": "ConfluenceUserInfo",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": (v16/*: any*/)
      },
      (v2/*: any*/)
    ]
  },
  {
    "concreteType": "ConfluenceContentVersion",
    "kind": "LinkedField",
    "name": "latestVersion",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "createdAt"
      }
    ]
  }
],
v18 = [
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "colorName"
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": (v16/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "updated"
  },
  {
    "kind": "ScalarField",
    "name": "created"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "concreteType": "ConfluenceUserInfo",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v19/*: any*/),
        (v15/*: any*/),
        (v2/*: any*/)
      ]
    },
    (v2/*: any*/)
  ]
},
v21 = [
  {
    "concreteType": "ConfluenceUserInfo",
    "kind": "LinkedField",
    "name": "author",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v19/*: any*/),
          (v2/*: any*/)
        ]
      },
      (v2/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "suggestedActionsV2Enabled",
                    "variableName": "suggestedActionsV2Enabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "RecommendedFeedInternal_AtlassianRecommendedFeed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThreadsV2_Query",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ConvoAiHomeThreadsResult",
            "kind": "LinkedField",
            "name": "convoai_homeThreads",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConvoAiHomeThreadsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConvoAiHomeThread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "sources",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConvoAiHomeThreadSource"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "ari"
                              },
                              (v5/*: any*/)
                            ],
                            "type": "ConvoAiHomeThreadsFirstPartySource"
                          },
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "ConvoAiHomeThreadSuggestedAction",
                        "kind": "LinkedField",
                        "name": "suggestedActions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "source",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v12/*: any*/),
                                        "type": "ConfluenceFooterComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v12/*: any*/),
                                        "type": "ConfluenceInlineComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v13/*: any*/),
                                        "type": "JiraPlatformComment"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v13/*: any*/),
                                        "type": "JiraServiceManagementComment"
                                      },
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ConvoAiHomeThreadsFirstPartySource"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "action"
                          },
                          {
                            "condition": "suggestedActionsV2Enabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v17/*: any*/),
                                            "type": "ConfluenceFooterComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v17/*: any*/),
                                            "type": "ConfluenceInlineComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v18/*: any*/),
                                            "type": "JiraPlatformComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v18/*: any*/),
                                            "type": "JiraServiceManagementComment"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v20/*: any*/),
                                              (v8/*: any*/),
                                              {
                                                "concreteType": "ConfluencePageVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": (v21/*: any*/)
                                              },
                                              (v14/*: any*/)
                                            ],
                                            "type": "ConfluencePage"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v20/*: any*/),
                                              (v8/*: any*/),
                                              {
                                                "concreteType": "ConfluenceBlogPostVersion",
                                                "kind": "LinkedField",
                                                "name": "latestVersion",
                                                "plural": false,
                                                "selections": (v21/*: any*/)
                                              }
                                            ],
                                            "type": "ConfluenceBlogPost"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "ConvoAiHomeThreadsFirstPartySource"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4971b9ad15faac4be78ffb2ad161f5508edd98913b088d599b2d846e1c844537",
    "metadata": {},
    "name": "ThreadsV2_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "164d0eebed4738877139818c541a2de0";

export default node;
